import { useEffect, useState } from 'react';
import { ContentApi } from '../../api/ContentApi';

export const useCosmeticContent = (): string => {
    const [getConfirmationText, setConfirmationText] = useState<string>('');

    useEffect(() => {
        fetchConfirmationText();
    }, []);

    type callbackObject = {
        confirmationText: string;
    };

    const fetchConfirmationText = () => {
        const successCallback = (result: callbackObject) => {
            setConfirmationText(result.confirmationText);
        };

        const failureCallback = () => {
            console.log('Failed to find confirmation text');
        };

        new ContentApi().getCosmeticText(successCallback, failureCallback);
    };

    return getConfirmationText;
};
